/**
 * TrendModa - Son Satın Alma Toast Bildirimi
 */
(function () {
  'use strict';

  var NAMES = [
    'Ayşe K.', 'Mehmet Y.', 'Zeynep Ö.', 'Ahmet D.', 'Elif S.',
    'Fatma Ç.', 'Mustafa T.', 'Hatice A.', 'İbrahim K.', 'Emine Y.',
    'Ali R.', 'Meryem B.', 'Hüseyin G.', 'Hacer M.', 'Ömer F.',
    'Şule K.', 'Yusuf E.', 'Büşra T.', 'Emre C.', 'Selin A.'
  ];

  var CITIES = [
    'İstanbul', 'Ankara', 'İzmir', 'Bursa', 'Antalya',
    'Adana', 'Gaziantep', 'Konya', 'Kayseri', 'Mersin',
    'Eskişehir', 'Trabzon', 'Samsun', 'Denizli', 'Kocaeli',
    'Diyarbakır', 'Malatya', 'Erzurum', 'Van', 'Şanlıurfa'
  ];

  var TIMES = [
    '2 dakika önce', '5 dakika önce', '8 dakika önce',
    '12 dakika önce', '3 dakika önce', '7 dakika önce',
    '1 dakika önce', '15 dakika önce'
  ];

  function getInterval() {
    var el = document.getElementById('purchaseToast');
    if (!el) return 20000;
    var parent = el.closest('[data-interval]');
    return (parseInt(parent ? parent.dataset.interval : '20', 10)) * 1000;
  }

  function showToast() {
    if (sessionStorage.getItem('toastClosed')) return;
    var toast = document.getElementById('purchaseToast');
    if (!toast) return;

    var name = NAMES[Math.floor(Math.random() * NAMES.length)];
    var city = CITIES[Math.floor(Math.random() * CITIES.length)];
    var time = TIMES[Math.floor(Math.random() * TIMES.length)];

    var nameEl = toast.querySelector('.purchase-toast__name');
    var timeEl = toast.querySelector('.purchase-toast__time');
    var cityEl = toast.querySelector('.purchase-toast__city');

    if (nameEl) nameEl.textContent = name;
    if (timeEl) timeEl.textContent = time;
    if (cityEl) cityEl.textContent = city;

    toast.style.display = 'block';
    toast.style.animation = 'none';
    void toast.offsetWidth;
    toast.style.animation = '';

    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.style.display = 'none';
    }, 6000);
  }

  function init() {
    var toast = document.getElementById('purchaseToast');
    if (!toast) return;

    setTimeout(showToast, 3000);
    setInterval(showToast, getInterval());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
